import { render, staticRenderFns } from "./ListEstate.vue?vue&type=template&id=88d16f90&scoped=true&"
import script from "./ListEstate.vue?vue&type=script&lang=js&"
export * from "./ListEstate.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=88d16f90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d16f90",
  null
  
)

export default component.exports